import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { KeyField } from 'src/redux/slices/umibuilder/consts'
import { makeSelectKeyFieldErrorMessage } from 'src/redux/slices/umibuilder/selectors'

import Button from '@material-ui/core/Button'

///// Types
type KeyFieldsErrorButtonProps = {
  setMapColorMode(arg: string): void
  keyField: keyof typeof KeyField
}

///// Component
const KeyFieldsErrorButton: React.FC<KeyFieldsErrorButtonProps> = ({
  setMapColorMode,
  keyField,
}) => {
  const errorSelector = useMemo(() => makeSelectKeyFieldErrorMessage(keyField), [keyField])
  const error = useSelector(errorSelector)
  return (
    <Button
      onClick={() => setMapColorMode(`${keyField}Error`)}
      size='small'
      color='secondary'
      variant='contained'
      disabled={error == ''}
    >
      Highlight Errors
    </Button>
  )
}

export default KeyFieldsErrorButton
